'use client';

import { forwardRef } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { adornedInputIconStyles } from './styles/adorned-input-icon.styles';
import type { AdornedInputIconPropsInterface } from './types/adorned-input-icon.types';

/**
 * @since 10.0.0
 */
export const AdornedInputIcon = forwardRef<SVGSVGElement, AdornedInputIconPropsInterface>(
  (props: AdornedInputIconPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="AdornedInput.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{
          ...adornedInputIconStyles,
          ...cssProp,
        }}
        {...rest}
        className={cx('c11n_adorned-input__icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

AdornedInputIcon.displayName = 'AdornedInput.Icon';
